import React, { useEffect, useRef, useState } from "react";
import "./footer.css";
import { PseudoContent } from "components/pseudoContent";

const Footer = () => {
  return (
    <PseudoContent>
      <div className="pageFooter">
        <div className="row">
          <div className="col-sm-8 d-flex align-items-center mt-2">
            <div className="pageFooterText no-before"></div>
          </div>
          <div className="col-sm-4">
            <div className="pageFooterLogo"></div>
          </div>
        </div>
      </div>
    </PseudoContent>
  );
};

export default Footer;
